import React from 'react'
import useModal from './modalHook';
import AddProduct from '../views/shared/settings/products/AddProduct';
import { useQueryClient } from '@tanstack/react-query';
import { PRODUCT_TYPES, PRODUCTS } from '../resources/enums';
import { FaCar, FaHome, FaMoneyBillWave, FaRobot } from 'react-icons/fa';
import { removeUnderscoresAndCapitalize } from '../utils/miscFunctions';

const useProduct = () => {

  const { ModalComponent, updateModalStates, closeModal } = useModal();
  const ProductModal = ModalComponent;
  const queryClient = useQueryClient();

  const addProduct = () => {
    updateModalStates({
      show: true,
      children: (
        <AddProduct
          onProceed={() => {
            closeModal();
            queryClient.invalidateQueries({ queryKey: ['getProducts'] });
          }}
          onClose={() => {
            closeModal();
          }}
        />
      ),
      title: 'Add New Product',
      classes: '!p-0 r-[5px]',
      size: 'lg'
    });
  };

  const ProductBadge: React.FC<ProductBadgeProps> = ({ productType, className = '' }) => {

    const productConfig = {
      [PRODUCT_TYPES.AUTO_INSURANCE || PRODUCTS.AUTO_INSURANCE]: {
        icon: <FaCar className="w-4 h-4 mr-1.5" />,
        bgColor: 'bg-blue-50',
        textColor: 'text-blue-700',
        borderColor: 'border-blue-200',
      },
      [PRODUCT_TYPES.HOME_INSURANCE || PRODUCTS.HOME_INSURANCE]: {
        icon: <FaHome className="w-4 h-4 mr-1.5" />,
        bgColor: 'bg-green-50',
        textColor: 'text-green-700',
        borderColor: 'border-green-200',
      },
      [PRODUCT_TYPES.AI_VEHICLE_VERIFICATION || PRODUCTS.AI_VEHICLE_VERIFICATION]: {
        icon: <FaRobot className="w-4 h-4 mr-1.5" />,
        bgColor: 'bg-purple-50',
        textColor: 'text-purple-700',
        borderColor: 'border-purple-200',
      },
      [PRODUCT_TYPES.PREMIUM_FINANCING || PRODUCTS.PREMIUM_FINANCING]: {
        icon: <FaMoneyBillWave className="w-4 h-4 mr-1.5" />,
        bgColor: 'bg-amber-50',
        textColor: 'text-amber-700',
        borderColor: 'border-amber-200',
      },
    };

    const config = productConfig[productType as keyof typeof productConfig] || {
      icon: null,
      bgColor: 'bg-gray-50',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-200',
    };

    return (
      <div
        className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${config.bgColor} ${config.textColor} ${config.borderColor} ${className}`}
      >
        {config.icon}
        <span>{productType ? removeUnderscoresAndCapitalize?.(productType) : '-'}</span>
      </div>
    );
  };


  return {
    addProduct,
    ProductModal,
    ProductBadge
  }

}

export default useProduct;


interface ProductBadgeProps {
  productType: string;
  className?: string;
}

